<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> app_registration </span>Gestion de
          stock
        </div>
      </div>
</div>
      <div id="contratTab" class="tabElementContent active">
        <!-- <div @click="addNewCustomerCommande" class="buttonAdd">
              <span> Ajouter un bon de commande</span>
            </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>

            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in soreStockData"
                :key="item._id"
              >
                <td @click="editeStockInventoryRow(item)">
                  {{ item.product ? item.product.name :'' }}
                </td>
                <td @click="editeStockInventoryRow(item)">
                  {{ item.product ? item.product.type  :'' }}
                </td>
                <td @click="editeStockInventoryRow(item)">
                  {{ item.quantity }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
        
        <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "manageInventory",
  components: {},
  data: () => ({
    tableHeader: ["Produit", "Type", "Quantité"],
    isSelecteds: [],
    isSelectedAll: false,
    tableHeaderBl: [
      "Contrat",
      "Numéro BL",
      "Nbr de conteneur",
      "Port de chargement",
      "Navire",
      "Ligne",
      "Destination",
      "Etdpol",
      "Eta",
      "Observation",
    ],
    tableHeaderConteneur: [
      "Commande",
      "Désignation",
      "Type de conteneur",
      "Numéro BL",
      "Produit",
      "Magasin",
      "Date de sourti",
      "Transitaire",
      "Montant Transitaire",
      "Montant total",
      "Observation",
    ],
    tableHeaderConteneurNone: [
      "",
      "Commande",
      "Désignation",
      "Type de conteneur",
      "Numéro BL",
      "Produit",
      "Transitaire",
      "Montant Transitaire",
      "Montant total",
      "Observation",
    ],
  }),
  watch: {
    contenuerAllData() {
      this.isSelecteds = [];
    },
  },
  computed: {
    ...mapGetters([
      "contratData",
      "blData",
      "conteneurData",
      "contenuerAllData",
      "storeData",
      "soreStockData",
    ]),
  },
  async mounted() {
    await this.getStoreStock({});
  },
  methods: {
    ...mapActions([
      "getCustomerList",
      "getProduct",
      "getContrat",
      "getStore",
      "getStoreStock",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },

    async addNewCustomerCommande() {
      this.$emit("show",true)
      await this.getCustomerList({});
      await this.getProduct({});
      await this.getStore({});
      const value = {
        modalType: "customerCommande",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "customerCommande",
        size: 300,
        value: value,
      });
      this.$emit("show",false)
    },

    editeStockInventoryRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.soreStockData.length; i++) {
          this.soreStockData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.soreStockData);
        const value = {
          _id: item._id,
          modalType: "stockInventory",
          product: item.product ? item.product.name :'' ,
          productType: item.product ? item.product.type :'' ,
          quantity: 0,
          store: item.store._id,
          isSurPlus: '',
          quantityDispos: item.quantity,
          productId: item.product._id,
          observation: 'Produit déficit',
        };
        this.$emit("editeRowForDash", {
          name: "stockInventory",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeBlRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.blData.length; i++) {
          this.blData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.blData);
        await this.getContrat({});
        const value = {
          _id: item._id,
          modalType: "bl",
          observation: item.observation,
          number: item.number,
          shipName: item.shipName,
          lineName: item.lineName,
          loadingPort: item.loadingPort,
          etdPol: item.etdPol,
          destination: item.destination,
          eta: item.eta,
          contract: item.contract ? item.contract.number : "",
        };
        this.$emit("editeRowForDash", {
          name: "bl",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeConteneurRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.contenuerAllData.length; i++) {
          this.contenuerAllData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log("OK", item);
        await this.getConteneur();
        await this.getContratDetails({});
        await this.getBl({});
        await this.getTransitaire();

        const value = {
          _id: item._id,
          modalType: "conteneurPrincipaleAll",
          observation: item.observation,
          containType: item.containType ? item.containType.name : "",
          store: item.store ? item.store.name : "",
          contractDetail: item.contractDetail ? item.contractDetail.number : "",
          name: item.name,
          bl: item.bl ? item.bl.number : "",
          product: item.product ? item.product.name : "",
          outDate: item.outDate,
          transitaire: item.transitaire ? item.transitaire.fullName : "",
          transitaireAmount: item.transitaireAmount,
          amount: item.amount,
        };
        this.$emit("editeRowForDash", {
          name: "conteneurPrincipaleAll",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async addNewContratDetails(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.contratData.length; i++) {
          this.contratData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.contratData);
        const value = {
          _id: item._id,
          modalType: "commande",
          number: item.number,
          supplier: item.supplier.fullName,
          observation: item.observation,
        };
        await this.getContratDetails({ contract: item._id });
        this.$emit("editeRowForDash", {
          name: "commande",
          size: 1000,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    //     makeSelectAll() {

    //   if (!this.isSelectedAll) {
    //     this.isSelectedAll = true;

    //     this.contenuerAllData.forEach((resourceItem) => {
    //       resourceItem.isSelected = true;
    //       this.isSelected.push(resourceItem._id);
    //     });

    //   } else {
    //     this.isSelectedAll = false;

    //     this.contenuerAllData.forEach((resourceItem) => {

    //       const index = this.isSelected.indexOf(resourceItem._id);
    //       resourceItem.isSelected = false;
    //       if (index !== -1) {
    //         this.isSelected.splice(index, 1);
    //       }
    //     });
    //   }
    // },
    makeSelect(item) {
      if (!item.isSelected) {
        item.isSelected = true; // Met item.isSelected à true

        this.isSelecteds.push(item._id);
      } else {
        item.isSelected = false;

        const index = this.isSelecteds.indexOf(item._id);
        if (index !== -1) {
          this.isSelecteds.splice(index, 1);
        }
      }
      // alert(JSON.stringify(this.selectedItemsIds));
    },
    async changeTab(tabName) {
      this.$emit("show",true)
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getContrat({});
      } else if (tabName === "bl") {
        await this.getBl({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show",false)
    },
  },
};
</script>
        